/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Nav, NavItem, NavLink, TabContent, TabPane, CardBody, Row, Col,
  Button, Card, Modal, ModalBody, ModalFooter,
} from 'reactstrap';

import classnames from 'classnames';
import moment from 'moment';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { POST_LISTING } from '../../helpers/url_helper';
import BaseGrid from '../Common/BaseGrid';

import {
  get, del, post, put,
} from '../../helpers/api_helper';

function UserLists(props) {
  const { t } = props;

  const [lists, setLists] = useState([]);
  const [activeList, setActiveList] = useState(null);
  const [activeListType, setActiveListType] = useState('items');
  const [signal, setSignal] = useState(0);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [byPartNumber, setByPartNumber] = useState(false);
  const [openAiListItems, setOpenAiListItems] = useState(false);
  const [openAiThinking, setOpenAiThinking] = useState(false);

  const listameRef = useRef(null);
  const partNumbersRef = useRef(null);
  const devilRef = useRef(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const askDevil = async () => {
    try {
      setOpenAiThinking(true);
      const results = await post(`/api/openai/populate-user-${activeListType}-list/${activeList}`, {
        question: devilRef.current.value,
      });

      setSignal(signal + 1);
      setOpenAiListItems(false);
    } catch (error) {
      toastr.error(error.message, t('Error populating list'));
    } finally {
      setOpenAiThinking(false);
    }
  };

  const loadLists = async () => {
    try {
      const res = await get('/api/lists/mine');
      const sortedLists = [...res].sort((a, b) => {
        const createdAtA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const createdAtB = b.created_at ? new Date(b.created_at).getTime() : 0;

        if (createdAtA !== createdAtB) {
          return createdAtA - createdAtB;
        }

        return a.id - b.id;
      });

      if (sortedLists.length > 0) {
        setLists(sortedLists);
      } else {
        setLists([]);
        setActiveList(null);
      }
    } catch (e) {
      toastr.error(t('Error loading remote data'));
    }
  };

  useEffect(() => {
    loadLists();
  }, [signal]);

  const toggleList = async (id, openTab) => {
    setActiveList(id);

    if (openTab !== null) {
      setActiveListType(openTab);
    } else {
      setActiveListType('items');
    }
  };

  const toggleListType = async (type) => {
    setActiveListType(type);
  };

  const removeItem = async (item) => {
    try {
      await del(`/api/lists/item/${item.id}`);
      setSignal(signal + 1);
    } catch (e) {
      toastr.error(t('Error removing item'));
    }
  };

  const removeListing = async (listing) => {
    try {
      await del(`/api/lists/listing/${listing.id}`);
      setSignal(signal + 1);
    } catch (e) {
      toastr.error(t('Error removing item'));
    }
  };

  const markChecked = async (listing) => {
    try {
      const result = await post(`/api/listings/mark-evaluated-subs/${listing.listing_id}`);
      toastr.success(`Listing ID ${listing.listing_id} saved`, 'Success');
    } catch (error) {
      toastr.error(`${error.message}: ${error.response.data}`, t('Error marking listing'));
    }
  };

  const markListingsLarge = async (large) => {
    if (!confirm(t(`Mark every listing in this list as ${large ? 'large' : 'not large'}?`))) return;

    try {
      const result = await put(`/api/lists/${activeList}/mark-listings-large/${large ? '1' : '0'}`);
      toastr.success(`${result.updated} listings updated`, 'Success');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, t('Error marking listings'));
    }
  };

  const createList = async () => {
    try {
      const data = {
        label: listameRef.current.value,
      };

      await post('/api/lists', data);
      setSignal(signal + 1);
      setIsCreateOpen(false);
    } catch (e) {
      toastr.error(t('Error creating list'));
    }
  };

  const removeList = async (id) => {
    try {
      if (confirm(t('Are you sure you want to delete this list?'))) {
        await del(`/api/lists/${id}`);
        setSignal(signal + 1);
      }
    } catch (e) {
      toastr.error(e.message, t('Error removing list'));
    }
  };

  const markItem = async (item, mark) => {
    try {
      await put(`/api/lists/mark/${item.id}/${mark ? '1' : '0'}`);
      setSignal(signal + 1);
    } catch (e) {
      toastr.error(t('Error marking item'));
    }
  };

  const insertPartNumbers = async () => {
    try {
      // Get part numbers and filter out empty ones
      const pns = partNumbersRef.current.value
        .split('\n')
        .map((pn) => pn.trim())
        .filter((pn) => pn.length > 0);

      if (pns.length === 0) {
        toastr.warning(t('No valid part numbers provided'));
        return;
      }

      // Fetch items by part numbers
      const res = await post('/api/items/pns', { part_numbers: pns });

      if (!res || !Array.isArray(res)) {
        toastr.error(t('Unexpected response from server'));
        return;
      }

      // Add each item to the list, allowing individual failures
      await Promise.all(
        res.map((x) => post(`/api/lists/${activeList}/add/${x.id}`).catch((err) => {
          toastr.warning(t(`Failed to add item ${x.id}`));
        })),
      );

      // Force refresh
      setSignal(signal + 1);
      partNumbersRef.current.value = '';
      setByPartNumber(false);
    } catch (e) {
      toastr.error(t('Error inserting part numbers'));
    }
  };

  useEffect(() => {
    const updateList = async () => {
      await put(`/api/lists/${activeList}`, { open_tab: activeListType });
    };

    if (activeList !== null) {
      // save tab preference for active list
      updateList();
    }
  }, [activeListType]);

  const jsx = (
    <>
      <Row className="user-lists-layout g-3">
        <Col lg="3" className="user-lists-nav-column pt-3 mb-0">
          <Button color="warning" className="btn-soft-warning text-dark mb-3" onClick={() => setIsCreateOpen(true)}>
            <span className="mdi mdi-plus" />
            {' '}
            {t('Create new list')}
          </Button>

          {isCreateOpen && (
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                ref={listameRef}
                placeholder={t('List name')}
                onKeyDown={() => {
                  if (event.key === 'Enter') {
                    createList();
                  }
                }}
              />
            </div>
          )}

          <ul
            className="list-group user-lists-nav-list"
          >
            {lists.map((x) => (
              <li
                key={x.id}
                className={classnames('list-group-item p-0')}
                style={{ cursor: 'pointer', border: 'none' }}
              >
                <div className="d-flex align-items-center">
                  <Button
                    color="link"
                    onClick={() => toggleList(x.id, x.open_tab)}
                    className={classnames(
                      'user-lists-list-button flex-grow-1 text-start', // Expands fully and aligns text left
                      { 'bg-warning text-dark fw-bold': x.id === activeList },
                      { 'text-muted': x.id !== activeList },
                    )}
                    style={{ borderRadius: '3px 0px 0px 3px' }} // Optional styling
                  >
                    {x.label.toUpperCase()}
                  </Button>
                  <Button
                    color="warning"
                    className={classnames(
                      'user-lists-list-remove',
                      { 'text-muted': x.id !== activeList },
                      { 'text-dark': x.id === activeList },
                      'btn-soft-warning',
                    )}
                    style={{ borderRadius: '0px 3px 3px 0px' }}
                    onClick={() => removeList(x.id)}
                  >
                    <span className="mdi mdi-close-thick" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        </Col>

        <Col lg="9" className="user-lists-panel pt-3 mb-0 pb-0">
          {activeList === null && (
            <p className="text-muted pt-2 text-center fs-5">
              {t('Please create a list')}
            </p>
          )}

          {activeList !== null && (
            <>
              <Nav tabs className="user-lists-tabs">
                <NavItem key="items">
                  <NavLink
                    className={classnames({ active: activeListType === 'items' })}
                    onClick={() => toggleListType('items')}
                  >
                    {t('Items')}
                  </NavLink>
                </NavItem>
                <NavItem key="listings">
                  <NavLink
                    className={classnames({ active: activeListType === 'listings' })}
                    onClick={() => toggleListType('listings')}
                  >
                    {t('Listings')}
                  </NavLink>
                </NavItem>
                <NavItem key="sales">
                  <NavLink
                    className={classnames({ active: activeListType === 'sales' })}
                    onClick={() => toggleListType('sales')}
                  >
                    {t('Sales')}
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                activeTab={activeListType}
                className="text-muted"
              >
                <TabPane tabId="items" key="items">
                  <Card style={{ borderRadius: '0 0 10 10' }}>
                    <CardBody className="mt-0 mb-2">
                      <Button color="primary" size="sm" className="btn-soft-primary mb-3" onClick={() => setByPartNumber(!byPartNumber)}>
                        <span className="mdi mdi-plus" />
                        {' '}
                        {t('Add items by Part Number')}
                      </Button>
                      <br />
                      <Button color="primary" size="sm" className="btn-soft-danger mb-3" onClick={() => setOpenAiListItems(true)}>
                        <span className="fas fa-journal-whills" />
                        {' '}
                        {t('Ask the Devil')}
                      </Button>

                      {byPartNumber && (
                        <div className="mb-3">
                          <textarea ref={partNumbersRef} className="form-control" placeholder={t('Part Numbers')} />
                          <Button color="primary" size="sm" className="btn-soft-primary mt-3" onClick={insertPartNumbers}>
                            <span className="mdi mdi-plus" />
                            {' '}
                            {t('Insert')}
                          </Button>
                        </div>
                      )}

                      <BaseGrid
                        url={`/api/lists/${activeList}/items`}
                        shouldUpdate={signal}
                        className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                        hasSearch
                        key={`${activeList}-${signal}-items`}
                        config={
                          {
                            columns: {
                              marked: {
                                label: '',
                                actions: [
                                  {
                                    key: 'mark',
                                    icon: 'mdi mdi-checkbox-blank-outline',
                                    class: 'btn btn-sm btn-link fs-2 p-1',
                                    alt: props.t('Mark Complete'),
                                    condition: (item) => (item.marked === 0),
                                    click: (item) => markItem(item, true),
                                  },
                                  {
                                    key: 'mark',
                                    icon: 'mdi mdi-check-box-outline',
                                    class: 'btn btn-sm btn-link fs-2 p-1 text-success',
                                    alt: props.t('Unmark Complete'),
                                    condition: (item) => (item.marked === 1),
                                    click: (item) => markItem(item, false),
                                  },
                                ],
                              },
                              thumb: {
                                label: '',
                                image: {
                                  src: (item) => (`/api/items/thumbnail/${item.item_id}`),
                                  class: 'rounded',
                                  style: { maxHeight: '5rem', maxWidth: '5rem' },
                                },
                                translate: false,
                              },
                              part_number: {
                                label: props.t('Part Number'),
                                sort: true,
                                link: {
                                  to: '/item/%item_id%',
                                },
                                format: (f, x) => (x.item.part_number),
                              },
                              board_numbers: {
                                label: props.t('Searchable'),
                                html: true,
                                style: { maxWidth: '200px', whiteSpace: 'wrap' },
                                format: (f, x) => (x.item.boardNumbers.filter((y) => y.label === 'Search').map((y) => y.value).join('<br />')),
                              },
                              total_used_quantity: {
                                label: props.t('Total Uses'),
                                sort: true,
                              },
                              sales_last_24h: {
                                label: props.t('Uses Last 24h'),
                                sort: true,
                              },
                              qty: {
                                label: props.t('Quantity'),
                                sort: true,
                                format: (f, x) => (x.item.qty),
                              },
                              days_left: {
                                label: props.t('Days Left'),
                                sort: true,
                                format: (f, x) => (Math.round(x.days_left)),
                              },
                              created_at: {
                                label: props.t('Added'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                              },
                              actions: {
                                label: props.t('Actions'),
                                actions: [
                                  {
                                    key: 'remove',
                                    icon: 'mdi mdi-close-thick',
                                    class: 'btn btn-sm btn-soft-danger',
                                    alt: props.t('Remove'),
                                    click: removeItem,
                                  },
                                ],
                              },
                            },
                            pagination: {
                              sort: 'days_left',
                              direction: 'asc',
                              perPage: 30,
                            },
                          }
                        }
                      />
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>

              <TabContent
                activeTab={activeListType}
                className="text-muted"
              >
                <TabPane tabId="listings" key="listings">
                  <Card style={{ borderRadius: '0 0 10 10' }}>
                    <CardBody className="mt-0 mb-0">
                      <Button color="primary" disabled={openAiThinking} size="sm" className="btn-soft-danger mb-3" onClick={() => setOpenAiListItems(true)}>
                        <span className="fas fa-journal-whills" />
                        {' '}
                        {t('Ask the Devil')}
                      </Button>
                      {' '}
                      <Button color="warning" size="sm" className="btn-soft-warning mb-3" onClick={() => markListingsLarge(true)}>
                        <span className="mdi mdi-package-variant" />
                        {' '}
                        {t('Mark all Large')}
                      </Button>
                      {' '}
                      <Button color="secondary" size="sm" className="btn-soft-secondary mb-3" onClick={() => markListingsLarge(false)}>
                        {t('Unmark all Large')}
                      </Button>

                      <BaseGrid
                        url={`/api/lists/${activeList}/listings`}
                        shouldUpdate={signal}
                        className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                        hasSearch
                        key={`${activeList}-${signal}-listings`}
                        config={
                          {
                            columns: {
                              thumb: {
                                label: '',
                                image: {
                                  src: (ll) => (`/api/listings/thumbnail/${ll.listing_id}`),
                                  class: 'rounded',
                                  style: { maxHeight: '6rem', maxWidth: '6rem' },
                                },
                                translate: false,
                              },
                              id: {
                                label: 'ID',
                                sort: true,
                                style: { minWidth: '100px' },
                                link: {
                                  to: '/listing/%listing_id%',
                                },
                                html: true,
                                format: (x, ll) => {
                                  if (ll.listing.last_qty > 0) {
                                    // In Stock
                                    return `<span class="badge bg-success"><span class="mdi mdi-check"></span></span> &nbsp;${ll.listing.id}`;
                                  }
                                  // OOS
                                  return `<span class="badge bg-warning bg-soft"><span class="mdi mdi-close-thick text-dark"></span></span> &nbsp;${ll.listing.id}`;
                                },
                              },
                              created_at: {
                                label: props.t('Created'),
                                format: (f, x) => (moment(x.listing.created_at).fromNow()),
                                sort: true,
                              },
                              sku: {
                                label: 'Sku',
                                sort: true,
                                style: {
                                  fontSize: '10px',
                                },
                                format: (f, x) => (x.listing.sku),
                              },
                              title: {
                                label: 'Title',
                                sort: true,
                                style: {
                                  fontSize: '11px',
                                  maxWidth: '200px',
                                  whiteSpace: 'normal',
                                },
                                format: (f, x) => (x.listing.title),
                              },
                              price: {
                                label: 'Price',
                                sort: false,
                                format: (x, ll) => new Intl.NumberFormat(
                                  'en-US',
                                  {
                                    style: 'currency',
                                    currency: 'USD',
                                  },
                                ).format(ll.listing.price),
                                style: { fontSize: '11px' },
                              },
                              last_qty: {
                                label: 'Qty',
                                sort: true,
                                style: { fontSize: '11px' },
                                format: (x, ll) => ll.listing.last_qty,
                              },
                              large_item: {
                                label: props.t('Large'),
                                format: (x, ll) => (ll.listing.large_item
                                  ? '<span class="badge bg-warning text-dark">Large</span>'
                                  : ''),
                                html: true,
                              },
                              actions: {
                                label: props.t('Actions'),
                                actions: [
                                  {
                                    key: 'remove',
                                    icon: 'mdi mdi-close-thick',
                                    class: 'btn btn-sm btn-soft-danger',
                                    alt: props.t('Remove'),
                                    click: removeListing,
                                  },
                                  {
                                    key: 'markChecked',
                                    icon: 'mdi mdi-check',
                                    class: 'btn btn-sm btn-soft-success',
                                    alt: props.t('Mark Subs Checked'),
                                    click: markChecked,
                                  },
                                ],
                              },
                            },
                            pagination: {
                              sort: 'created_at',
                              direction: 'desc',
                              perPage: 30,
                            },
                          }
                        }
                      />
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>
            </>
          )}
        </Col>
      </Row>

      <Modal size="md" isOpen={openAiListItems}>
        <ModalBody>
          <p>{t('Anything you wish for might come true.')}</p>
          <textarea ref={devilRef} className="form-control" />
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => setOpenAiListItems(false)}
            className="btn btn-soft-dark"
            data-dismiss="modal"
          >
            {t('Cancel')}
          </Button>
          <Button
            color="primary"
            onClick={askDevil}
          >
            {t('Populate List')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );

  return jsx;
}

UserLists.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect((state) => ({

}), {})(withTranslation()(UserLists));
